module.exports = __webpack_public_path__ + "img/hired.4b9c0a8b.svg";